module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Duplicação de Marcação")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('strong', [_vm._v("ATENÇÃO:")]), _vm._v(" Encontra-se em aberto uma ou mais marcações com o procedimento selecionado para esse paciente, conforme pode ser visto na tabela abaixo:\n        ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Número")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Data da Solicitação")]), _vm._v(" "), _c('th', [_vm._v("Situação")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.solicitacoesNaoResolvidas), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itens[0].contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataHoraFormatada")(item.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("situacaoSolicitacao")(item.situacao)))])])
  }))]), _vm._v(" "), _c('p', [_vm._v("\n          Para continuar assim mesmo, informe uma\n          "), _c('strong', [_vm._v("JUSTIFICATIVA")]), _vm._v(" e sua\n          "), _c('strong', [_vm._v("SENHA")]), _vm._v(" nos campos abaixo, e clique em confirmar:\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Justificativa")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.justificativa),
      expression: "justificativa"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.justificativa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.justificativa = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.justificativaInvalida),
      expression: "justificativaInvalida"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Informe uma justificativa")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Digite sua senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.senha),
      expression: "senha"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center",
      "font-size": "20px",
      "padding": "20px"
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.senha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.senha = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.senhaInvalida),
      expression: "senhaInvalida"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Senha inválida")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.confirma
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Confirmar\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-35e33ad8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atendimentos/solicitacao/modalDuplicacao.vue
// module id = 826
// module chunks = 0